import styles from './NoizeValue.module.css';

export const NoizeValue = ({ noiseLevel }) => {
  const noiseLevelString = noiseLevel
    ? noiseLevel?.replaceAll('.', ',')?.split('')
    : '';

  return (
    <div className={styles.noiseLevel}>
      {noiseLevelString && (
        <div className={styles.stringValue}>
          {noiseLevelString?.map((l, i) => (
            <div key={i} className={`${l === ',' ? styles.comma : ''}`}>
              {l}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
